export var DEFAULT_LS_ACCESS_TOKEN_KEY = '__AUTH__TOKEN__';
export var DEFAULT_LS_REFRESH_TOKEN_KEY = '__AUTH__REFRESH__TOKEN__';
export var DEFAULT_LS_EXCHANGE_TOKEN_KEY = '__EXCHANGE__TOKEN__';
